import { useMemo, useState } from 'react';
import StatsGrid from '../components/layout/StatsGrid';
import InvoiceList from '../components/invoice/InvoiceList';

export default function InvoiceListPage({ tab, stats, dailyLimit, invoices, loading, onOpen, onDelete, onDownload }) {
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return invoices;
    return invoices.filter(inv =>
      String(inv.invoiceNo || '').toLowerCase().includes(q) ||
      String(inv.supplier || '').toLowerCase().includes(q) ||
      String(inv.date || '').toLowerCase().includes(q)
    );
  }, [invoices, search]);

  return (
    <>
      {/* <StatsGrid tab={tab} stats={stats} dailyLimit={dailyLimit} /> */}
      <div style={{ marginBottom: 16 }}>
        <input
          className="form-input"
          type="text"
          placeholder={`Search ${tab === 'sale' ? 'sale' : 'purchase'} invoices by number, name, or date...`}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ width: '100%', maxWidth: 420 }}
        />
      </div>
      <InvoiceList
        invoices={filtered}
        dailyLimit={dailyLimit}
        type={tab}
        onOpen={onOpen}
        onDelete={onDelete}
        onDownload={onDownload}
        loading={loading}
      />
    </>
  );
}
